var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTelegramIconWhite = function SvgTelegramIconWhite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1006_2394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2541 1.54043L1.37783 7.27657C0.362343 7.68392 0.368501 8.25044 1.19272 8.50273L5.00965 9.69418L6.3224 14.0146C6.495 14.491 6.40991 14.68 6.91038 14.68C7.29646 14.68 7.46701 14.5035 7.68254 14.2939L9.53754 12.4902L13.3966 15.3415C14.1069 15.7334 14.6194 15.5303 14.7963 14.6822L17.3298 2.74383C17.5892 1.70371 16.9335 1.23198 16.2541 1.54043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92697 13.5317L5.66797 9.38835L15.3591 3.63916L8.19754 10.6903L6.92697 13.5317Z",
    fill: "#080808"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1006_2394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTelegramIconWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "telegram-icon-white.f1f069d909b1b503c7106b3b04d22999.svg";